import { ItemBidsTriggerController } from "./item-bids-trigger.controller";

angular
    .module("thor.online-containers.edit.item-bids-trigger.component", [])
    .component("itemBidsTrigger", {
        bindings: {
            itemId: "<"
        },
        controller: ItemBidsTriggerController,
        template: require("./item-bids-trigger.html")
    });
